/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelfReportUnderageResponse
 */
export interface SelfReportUnderageResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SelfReportUnderageResponse
     */
    disabled: boolean;
    /**
     * Where to write if this was a mistake.
     * @type {string}
     * @memberof SelfReportUnderageResponse
     */
    helpContact: string;
}

/**
 * Check if a given object implements the SelfReportUnderageResponse interface.
 */
export function instanceOfSelfReportUnderageResponse(value: object): value is SelfReportUnderageResponse {
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('helpContact' in value) || value['helpContact'] === undefined) return false;
    return true;
}

export function SelfReportUnderageResponseFromJSON(json: any): SelfReportUnderageResponse {
    return SelfReportUnderageResponseFromJSONTyped(json, false);
}

export function SelfReportUnderageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelfReportUnderageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'disabled': json['disabled'],
        'helpContact': json['helpContact'],
    };
}

export function SelfReportUnderageResponseToJSON(json: any): SelfReportUnderageResponse {
    return SelfReportUnderageResponseToJSONTyped(json, false);
}

export function SelfReportUnderageResponseToJSONTyped(value?: SelfReportUnderageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled': value['disabled'],
        'helpContact': value['helpContact'],
    };
}

